import React from 'react';
import {Call} from '@store/call-card/Call';
import {UserAvatar} from '@components/util/UserAvatar';
import './ExternalCallHeader.sass';

interface ExternalCallHeaderProps {
  call: Call;
}

export const ExternalCallHeader: React.FC<ExternalCallHeaderProps> = ({call}) => {
  return (
    <div className="external-call-header">
      <div className="call-info">
        <div className="caller">
          <UserAvatar user={call.caller} />
          <h1>{call.caller.getFullName()}</h1>
        </div>
        <div className="call-template">
          <div className="line-one">{call.template.lineOne}</div>
          <div className="line-two">{call.template.lineTwo}</div>
        </div>
      </div>
    </div>
  );
};
